import React from "react";
import { useSnackBar } from "~/components/snackbar";
import FormBottomRow from "~/components/form-bottom-row";
import TextFormField from "~/components/text-form-field";
import { EeCodePickerFormField } from "~/visuals/organisms/EeCodePickerFormField";
import { useEditChargesEeCodeMutation } from "./editEeCode.hotchoc.generated";
import { ErrorRenderer, MutationForm } from "~/components/forms/MutationForm";
import { ValidationResponse, EeCodeRecord } from "~/gql/types";

type ChangeChargeEeCodeFormProps = {
  setOpen: React.Dispatch<boolean>;
  entries: number[];
  resetCharges: (ids: number[]) => Promise<void>;
};

type FormValues = {
  eeCode: EeCodeRecord | null;
  notes: string | null;
};

export const ChangeChargeEeCodeForm: React.FC<ChangeChargeEeCodeFormProps> = ({
  setOpen,
  entries,
  resetCharges,
}) => {
  const addAlert = useSnackBar();

  const initialValues = {
    eeCode: null,
    notes: null,
  };

  const [doMutation] = useEditChargesEeCodeMutation();

  const onSuccess = ({ values }) => {
    setOpen(false);
    addAlert({
      key: `${Math.random()}`,
      message: `Charge${entries?.length ? "s" : ""} ee code changed to ${
        values.eeCode.eeCode
      }`,
      isSuccess: true,
    });
    void resetCharges(entries);
  };

  const handleSubmit = async (values: FormValues) => {
    const variables = {
      input: {
        projectCharges: entries,
        eeCode: values.eeCode!.eeCode,
        editNotes: values.notes!,
      },
    };

    const result = await doMutation({ variables });
    return result?.data?.projectCharges?.editEeCode as ValidationResponse;
  };

  return (
    <MutationForm
      onSuccess={onSuccess}
      runMutation={handleSubmit}
      initialValues={initialValues}
    >
      <EeCodePickerFormField formField="eeCode" label="EE Code" helperText="" />
      <TextFormField
        formField="notes"
        label="Notes"
        helperText="Please explain the reason for the change"
        required
      />
      <ErrorRenderer
        render={(error) => (
          <FormBottomRow
            errorMessage={error}
            buttonText="Save"
            onCancel={() => setOpen(false)}
          />
        )}
      />
    </MutationForm>
  );
};
